// extracted by mini-css-extract-plugin
module.exports = {"container":"_1L50i9pB","title":"_2AoQ-G-p","flexContainer":"_16_LfgIj","detailContainer":"_2f_HA1Yu","highlighted":"_2XkJiOW1","highlightedRed":"_17GOjrJi"};
    if(module.hot) {
      // 1754515030039
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  